import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import config, { MenuI } from '../../assets/config';
import { useAppDispatch, useAppSelector } from '../../store/reduxHooks';
import { useLogoutMutation } from '../../services/rtkQueryServices';
import { resetAuth } from '../../store/authSlice';
import Logo from '../../assets/images/logo.png';
import LogoWhite from '../../assets/images/logo_white.png';
import { toggleDrawer } from '../../store/uxSlice';
import { useNavigate } from 'react-router-dom';

// const pages = ['Products', 'Pricing', 'Blog'];

function ResponsiveAppBar(props: any) {
  const [logoutApi] = useLogoutMutation();
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = (menuItem: MenuI) => {
    setAnchorElUser(null);
    switch (menuItem.id) {
      case 'user-menu-logout':
        logoutApi({}).finally(() => {
          dispatch(resetAuth());
        });
        break;
      default:
        navigate(menuItem.route);
        break;
    }
  };

  const toggleDrawerClick = () => {
    dispatch(toggleDrawer());
  };

  return (
    <AppBar
      position='fixed'
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Toolbar>
        <IconButton
          size='large'
          edge='start'
          color='inherit'
          aria-label='menu'
          onClick={toggleDrawerClick}
          sx={{
            mr: 2,
            display: {
              xs: 'block',
              md: 'none',
            },
          }}
        >
          <MenuIcon />
        </IconButton>
        {/* <AdbIcon sx={{ mr: 1 }} /> */}
        <img src={false ? Logo : LogoWhite} style={{ height: '50px' }} />
        <Typography
          variant='h6'
          noWrap
          component='a'
          href='/'
          sx={{
            mr: 2,
            display: { xs: 'none', md: 'flex' },
            fontFamily: 'monospace',
            fontWeight: 700,
            color: 'inherit',
            textDecoration: 'none',
          }}
        >
          {/* {config.appName}  */}
        </Typography>

        <Box sx={{ flexGrow: 1 }} />

        <Box sx={{ flexGrow: 0 }}>
          <Tooltip title='Open settings'>
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar
                alt={user?.displayName || 'A'}
                src={
                  user.displayName
                    ? '/api/admin/v1/file/profile/' + user.displayName
                    : ''
                }
                sx={{ width: 46, height: 46 }}
              />
            </IconButton>
          </Tooltip>
          <Menu
            sx={{ mt: '45px' }}
            id='menu-appbar'
            anchorEl={anchorElUser}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
          >
            {config.userMenu.map((setting: MenuI) => (
              <MenuItem
                key={setting.id}
                onClick={() => handleCloseUserMenu(setting)}
              >
                <Typography textAlign='center'>{setting.label}</Typography>
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
export default ResponsiveAppBar;
